import TeacherContent from "../../../../views/digibord/content/season/TeacherContent.vue";

export default [
  {
    path: "leerkracht/",
    name: "TeacherContent",
    component: TeacherContent,
    meta: {
      containerClass: "showTeacherContent",
    },
    children: [
      {
        path: ":seasonSlug/",
        name: "TeacherContentWithSeason",
        component: TeacherContent,
      },
    ],
  },
];
